import { render, staticRenderFns } from "./ApprovedContracts.vue?vue&type=template&id=7e44bc72&"
import script from "./ApprovedContracts.vue?vue&type=script&lang=js&"
export * from "./ApprovedContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports